import Panel from '@pjn/components/panel/Panel.vue';

/**
 * Componentes Globales.
 *
 * Estos se podran utilizar en cualquier componente sin la necesidad de declararlos en el mismo.
 * Esta lista debe tener SOLO los necesarios a nivel global, no poner componentes que no se usan o
 * que se necesitan en pocos componentes. En ese caso es mejor declararlo donde se necesita.
 *
 * NO incluir los de Vuetify, esos se enumeran en el archivo especifico de Vuetify
 */
export const GLOBAL_COMPONENTS = { Panel };
